<div class="navigation" [ngClass]="{
    'navigation--open': isOpen
}">
    <div
        class="search-container"
        (clickOutside)="clearSearch()"
        exclude="kd-search-results"
    >
        <input
            class="search"
            placeholder="Search"
            type="text"
            [(ngModel)]="query"
            (ngModelChange)="onSearch()"
            (keydown)="onSearchKey($event)"
        >
    </div>

    <div class="apps">
        <div *ngFor="let app of navigation" class="app" [ngClass]="{
            'app--active': isAppActive(app)
        }">
            <a
                class="app-name navigation-item"
                [routerLink]="getFirstPageLink(app)"
            >
                {{app.name}}
            </a>

            <div *ngIf="isAppActive(app)" class="categories">
                <div *ngFor="let category of app.categories" class="category">
                    <div *ngIf="category.name" class="category-name navigation-item">{{category.name}}</div>
                    <div *ngFor="let page of getPages(category)">
                        <a
                            class="page-name navigation-item"
                            routerLink="/{{app.slug}}/{{category.slug}}/{{page.slug}}"
                            routerLinkActive="page-name--active navigation-item-active"
                            style="display: inline-flex"
                        >
                            {{page.name}}
        
                            <a *ngIf="!page.is_public && isStaff" class="lock-button" (click)="toggleVisibility($event, page)">
                                <svg class="lock-icon kd-icon--s" kdSldsIcon="lock"></svg>
                            </a>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<kd-search-results [results]="results"></kd-search-results>

<div
    class="backdrop"
    [ngClass]="{
        'backdrop--open': isOpen
    }"
    (click)="closeMenu()"
></div>
